export function LaserUnitFactory() {
    return function LaserUnit() {
        this.name = null;
        this.code = null;
        this.id = null;
    }
}
